import { useState } from 'react'
import { useSelector } from 'react-redux'
import { clsx as c } from 'clsx'

import ApplyReferralTab from './components/ApplyReferralTab'
import CreateUserTab from './components/CreateUserTab'
import ManageUserTab from './components/ManageUserTab'
import UpdateUserTrialTab from './components/UpdateUserTrialTab'

import styles from './styles.module.scss'

import Tabs from '@/components/Tabs'
import { selectIsInternalAdmin } from '@/store/features/user/userSlice'

const tabs = ['Create', 'Manage', 'Referrals', 'Update Trial']

const UsersPage = () => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const [activeTab, setActiveTab] = useState(0)

  if (!isInternalAdmin) {
    return (
      <div className={styles.container}>
        <p>You are not authorized to access this page</p>
      </div>
    )
  }

  return (
    <div className={c(styles.container, styles.usersContainer)}>
      <div className={c(styles.tabTitle, styles.pageTabTitle)}>
        <h6>Users</h6>
        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      {activeTab === 0 && <CreateUserTab />}
      {activeTab === 1 && <ManageUserTab />}
      {activeTab === 2 && <ApplyReferralTab />}
      {activeTab === 3 && <UpdateUserTrialTab />}
    </div>
  )
}

export default UsersPage
